export const evalCartType = (cartType, totalPrice) => ({
    isMixedCart: cartType === 'MIXED',
    isRegularCart: cartType === 'REGULAR',
    isDigitalCart: cartType === 'DIGITAL' && !!totalPrice && !!totalPrice.value, // Remove this line when cart type loyalty is implemented on BE
    isLoyaltyCart: cartType === 'DIGITAL' && !(!!totalPrice && !!totalPrice.value), // Remove this line when cart type loyalty is implemented on BE
});

export const calculateMaxQuantity = (entry, stockReservationEnabled, forceMaxOrderQuantity) => {
    const { product = {}, quantity } = entry || {};
    let { stock = {}, maxOrderQuantity } = product;
    const { stockLevel, stockLevelStatus } = stock;
    maxOrderQuantity = +maxOrderQuantity || 0;

    // For force enabled products
    const stockItems =
        (!stockLevel && stockLevelStatus === 'inStock') || forceMaxOrderQuantity
            ? maxOrderQuantity
            : stockLevel;

    return Math.min(+stockItems + (stockReservationEnabled ? +quantity : 0) || 0, maxOrderQuantity);
};

export const getFormattedAddress = address => {
    if (!address) return '';
    const regex = new RegExp('^(\\S+? \\S+?) ([\\s\\S]+?)$', 'gm');
    const addressFirstLine = address.replace(regex, '$1');
    const addressSecondLine = address.replace(regex, '$2');

    return { addressFirstLine, addressSecondLine };
};
